import {DateTimeFormatter} from 'js-joda'

export function minuteDateTimeFormatter(): DateTimeFormatter {
    return DateTimeFormatter.ofPattern('HH:mm, dd.MM.yyyy')
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/View/Utils.tsx